import React from 'react'
import {Trans} from 'react-i18next'

import {FormControl, FormLabel, TextField, Typography} from '@mui/material'

import {
  TextAreaQuestion,
  questionTitleStyles,
} from '@progyny/pages/Consultations/components/questions/types'

interface TextAreaQuestionRendererProps {
  question: TextAreaQuestion
  formData: Record<string, string>
  handleInputChange: (questionId: string, value: string) => void
  isSubmitting: boolean
  colors: {primary: string; secondary: string}
}

const TextAreaQuestionRenderer: React.FC<TextAreaQuestionRendererProps> = ({
  question,
  formData,
  handleInputChange,
  isSubmitting,
  colors,
}) => (
  <FormControl
    component='fieldset'
    fullWidth
    sx={{maxWidth: '640px', margin: '0 auto'}}
  >
    <FormLabel component='legend' sx={{marginBottom: '38px'}}>
      <Typography sx={questionTitleStyles}>
        <Trans>{question.title}</Trans>
      </Typography>
    </FormLabel>
    <TextField
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: '2px',
          borderColor: '#EAECF0',
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: `${colors.primary} !important`,
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
          {
            borderColor: `${colors.primary} !important`,
          },
      }}
      multiline
      rows={question.rows || 4}
      placeholder={question.placeholder}
      value={formData[question.id] || ''}
      onChange={(e) => handleInputChange(question.id, e.target.value)}
      disabled={isSubmitting}
      fullWidth
    />
  </FormControl>
)

export default TextAreaQuestionRenderer
